import { ImageFragmentFragment } from '../../../__generated__/graphql';
import Svg from '../../../components/Svg';
import { Paragraph } from '../../../components/Text';

import style from './solutions-card.module.css';

interface SolutionsCardProps {
  description: string;
  image: ImageFragmentFragment | null | undefined;
}

// Component Definition
const SolutionsCard = ({
  description,
  image,
}: SolutionsCardProps) => (
  <div className={style.solutionsCard}>
    <Svg
      containerClassName={style.solutionsCardImageContainer}
      image={image}
    />

    <Paragraph>
      {description}
    </Paragraph>
  </div>
);

export default SolutionsCard;
